import React from 'react';
import ServiceCard from './ServiceCard.js';
import { websiteData } from '../data/websiteData.js';

export default function Services() {
  return (
    <section id="services" className="section" style={{ backgroundColor: 'var(--background)' }}>
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2>Our Services</h2>
          <p>
            Vijay Industry delivers professional, custom-engineered pre-engineered building (PEB) systems designed for industrial, commercial, and warehousing needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {websiteData.services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}
